export default __webpack_public_path__ + "static/media/cash_pickup.8dfb0568.svg";